export default "__VITE_ASSET__602a0d56__"